module.exports = __webpack_public_path__ + "media/images/trash_2-3b0243539a46363581efab649df37b18.svg";